var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobUpdated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 16.0165H4.16667V5.83317H10V4.1665H4.16667C3.25 4.1665 2.5 4.9165 2.5 5.83317V15.8332C2.5 16.7498 3.25 17.4998 4.16667 17.4998H14.1667C15.0833 17.4998 15.8333 16.7498 15.8333 15.8332V9.99984H14.1667V16.0165Z",
    fill: "#248EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 7.5H5.83325V9.16667H12.4999V7.5Z",
    fill: "#248EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 10V11.6667H12.4999V10H9.99992H5.83325Z",
    fill: "#248EB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 12.5H5.83325V14.1667H12.4999V12.5Z",
    fill: "#248EB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.37 7.37L16 8L17.37 8.63L18 10L18.63 8.63L20 8L18.63 7.37L18 6L17.37 7.37ZM15 6L15.94 3.94L18 3L15.94 2.06L15 0L14.06 2.06L12 3L14.06 3.94L15 6Z",
    fill: "#248EB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobUpdated);
export default __webpack_public_path__ + "static/media/job_updated.9202091e91fb9e7fba3358eb7cefbae2.svg";
export { ForwardRef as ReactComponent };